import React from 'react'

const Footer = ({currentPage,
                numberOfPages,
                handleCurrentPage,
                handleDelete,
                handleNext,
                handlePrev,
                handleEnd,
                handleStart}) => {

  return (
    <footer className="footer">
            <button
            onClick={handleDelete}
            >Delete Selected</button>
            <div className="pagination-controller">
                {
                    currentPage !== 1 && 

                    <>
                        <button
                        onClick={handleStart}
                        >Start</button>
                        <button
                        onClick = {handlePrev}
                        >Previous</button>
                    </>
                }
                

                {
                    Array.from({length: numberOfPages}, (v, i) => i+1).map((page) =>{

                        return <button
                                style ={
                                    {
                                        backgroundColor : page === currentPage ? '#0D6EFD' : "" ,
                                        color : page === currentPage ? 'white' : ""
                                    }
                                }
                                    onClick={() => {
                                        handleCurrentPage(page);
                                    }}
                                    key={page}>
                                        {page}
                                </button>
                    })
                }
                {
                    currentPage !== numberOfPages && 
                    <>
                        <button
                        onClick={handleNext}
                        >Next</button>
                        <button
                        onClick = {handleEnd}
                        >End</button>
                    </>
                }   


            </div>
        </footer>
  )
}

export default Footer